// F-04/F-05 source fallback while translations are pending.
export const DAILY_RITUAL_DE = {
  "daily_thread.title": "Tagesfaden",
  "daily_thread.progress": "Tagesfaden: {count} von 3 eigenen Nachrichten",
  "daily_thread.streak": "An {days} Folgetagen aktiv",
  "daily_thread.protection": "Serienschutz diese Woche: {remaining} von {total} übrig",
  "daily_thread.protection_info": "Ein ausgelassener Tag wird automatisch geschützt. Plus, Ultra und Founders schützen zwei Tage je Kalenderwoche. Geschützte Tage zählen nicht als Aktivitätstage.",
  "daily_thread.not_ready": "Nach drei eigenen Nachrichten im Abenteuer oder mit einem Begleiter kannst du den Tagesfaden abholen: Er schenkt dir drei Rabatt-Marken für weitere Nachrichten; zuvor gelten deine normalen Inklusivleistungen und Preise.",
  "daily_thread.ready": "Dein Tagesfaden ist geschafft. Hole dir drei Rabatt-Marken auf dem Dashboard ab.",
  "daily_scene.title": "Heute in Lorath",
  "daily_scene.play": "Szene starten",
  "push.daily_scene.title.0": "Heute in Lorath",
  "push.daily_scene.body.0": "Eine neue Szene wartet auf dich. Wohin führt deine Geschichte heute?",
  "push.daily_thread_risk.title.0": "Dein Tagesfaden wartet",
  "push.daily_thread_risk.body.0": "Noch {count} eigene Nachrichten bis zu deinem Tagesziel. Setze dein Gespräch fort.",
  "push.daily_thread_ready.title.0": "Dein Tagesfaden ist geschafft",
  "push.daily_thread_ready.body.0": "Deine 3 Rabatt-Marken liegen bereit. Kehre in dein Gespräch zurück.",
  "daily_chest.title": "Tagesfaden",
  "daily_chest.days_collected": "An {days} Folgetagen aktiv",
  "milestones.tab_chest": "Tagesfaden"
};
export const DAILY_RITUAL_EN = {
  "daily_thread.title": "Daily thread",
  "daily_thread.progress": "Daily thread: {count} of 3 messages of your own",
  "daily_thread.streak": "Active on {days} consecutive days",
  "daily_thread.protection": "Streak protection this week: {remaining} of {total} remaining",
  "daily_thread.protection_info": "One missed day is protected automatically. Plus, Ultra and Founders protect two days per calendar week. Protected days do not count as active days.",
  "daily_thread.not_ready": "After three messages of your own in an adventure or with a companion, you can claim the daily thread: it gives you three discount tokens for further messages; your usual allowances and prices apply beforehand.",
  "daily_thread.ready": "Your daily thread is complete. Claim three discount tokens on the dashboard.",
  "daily_scene.title": "Today in Lorath",
  "daily_scene.play": "Start scene",
  "push.daily_scene.title.0": "Today in Lorath",
  "push.daily_scene.body.0": "A new scene is waiting for you. Where will your story lead today?",
  "push.daily_thread_risk.title.0": "Your daily thread awaits",
  "push.daily_thread_risk.body.0": "Just {count} more messages of your own to reach your daily goal. Continue your conversation.",
  "push.daily_thread_ready.title.0": "Your daily thread is complete",
  "push.daily_thread_ready.body.0": "Your 3 discount tokens are ready. Return to your conversation.",
  "daily_chest.title": "Daily thread",
  "daily_chest.days_collected": "Active on {days} consecutive days",
  "milestones.tab_chest": "Daily thread"
};
